import { mapElectedRiders } from '../../PlanCard/utils';
import { VolumeElectionParamProps, VolumeElectRequestDto } from '../types';

export const volumeElectionParams = ({
  plan,
  orgBenefitId,
  enrollmentContextType,
  selectedDependentIds,
  selectedVolume,
  selectedIncrementValue,
  selectedIncrementValues,
  terminationReasonId,
  esignPassword,
  esignChecked,
  electedRiders,
  coverageLineId,
}: VolumeElectionParamProps) => {
  if (!orgBenefitId || !enrollmentContextType) {
    return {} as VolumeElectRequestDto;
  }

  const riderMapping = mapElectedRiders(electedRiders, coverageLineId);
  const params = {
    org_benefit_id: orgBenefitId,
    election: {
      org_plan_id: plan.plan_id,
      coverage_level_id: plan.level_id,
      dependent_ids: selectedDependentIds,
      subscriber_amount: selectedVolume,
      increment: selectedIncrementValue,
      line_increments: selectedIncrementValues,
    },
    esign_password: esignPassword,
    esign_checked: esignChecked,
    enrollment_context_type: enrollmentContextType,
    termination_reason_id: terminationReasonId,
    ...riderMapping,
  };
  return params as VolumeElectRequestDto;
};
